import {useMutation} from '@tanstack/react-query'
import fileDownload from 'js-file-download'
import {
  fetchCustomerIssueCheckmetersExcel,
  fetchCustomerIssueListExcel,
} from 'utils/apiCalling/reactQueryApi'
import {resultAlert} from 'utils/CustomAlert/Alert'
import {globalFormatWithHyphens} from 'utils/const/globalConst'

/*********************************************************************
 ** FlaggedReview 전용 엑셀 다운로드 mutation
 ** 공용 ExcelDownloadModal(pathname 분기 switch)에 의존하지 않고
 ** flagged-review 전용 엔드포인트(/customer-issues/excel,
 ** /customer-issue/checkmeters/excel)를 직접 연결한다.
 ** - 순수 blob 호출은 reactQueryApi.ts, 파일 저장·결과 알림은 여기서 처리
 *********************************************************************/

/** 목록 엑셀 다운로드 (메인 페이지) */
export const useFlaggedReviewListExcel = (officeInfo: any, cooperInfo: any) => {
  const listMutation = useMutation({
    mutationFn: (filter: any) => fetchCustomerIssueListExcel(officeInfo, cooperInfo, filter),
    onSuccess: async (blob: any, filter: any) => {
      await resultAlert({resultCode: 0})
      fileDownload(
        blob,
        `${officeInfo?.label}_${filter?.startIssueDate}~${filter?.endIssueDate}_확인이 필요한 수용가.xlsx`
      )
    },
    onError: async (e: any) => {
      await resultAlert({resultCode: e?.response?.status ?? 400})
    },
  })

  return {
    // options로 성공 콜백(예: 모달 닫기) 등을 전달할 수 있다
    downloadList: (filter: any, options?: {onSuccess?: () => void}) =>
      listMutation.mutate(filter, options),
    isListDownloading: listMutation.isPending,
  }
}

/** 상세 검침 이력 엑셀 다운로드 (상세 모달) */
export const useFlaggedReviewDetailExcel = (officeId: any, customerNumber: any) => {
  const detailMutation = useMutation({
    mutationFn: (filter: any) =>
      fetchCustomerIssueCheckmetersExcel(officeId, customerNumber, filter),
    onSuccess: async (blob: any, filter: any) => {
      await resultAlert({resultCode: 0})
      fileDownload(
        blob,
        `${globalFormatWithHyphens(officeId, customerNumber)}수용가_${filter?.startDate}~${
          filter?.endDate
        }_검침상세정보.xlsx`
      )
    },
    onError: async (e: any) => {
      await resultAlert({resultCode: e?.response?.status ?? 400})
    },
  })

  return {
    downloadDetail: (filter: any) => detailMutation.mutate(filter),
    isDetailDownloading: detailMutation.isPending,
  }
}
